import type { MeResponse } from '../identity/types';

/** The seeded role name the invitation acceptance assigns. */
export const EMPLOYEE_ROLE_NAME = 'Employee';

/**
 * True when the signed-in user is acting as an Employee: the ACTIVE company's membership holds the Employee role, or (before a
 * company is active) every membership they hold is the Employee role. This only chooses which screens to show; the server
 * authorizes every employee request from the token's role and employee id claim.
 */
export function isEmployeeSession(me: Pick<MeResponse, 'activeCompanyId' | 'memberships'>): boolean {
  if (me.memberships.length === 0) return false;
  const active = me.activeCompanyId ? me.memberships.find((m) => m.companyId === me.activeCompanyId) : undefined;
  if (active) return active.roleName === EMPLOYEE_ROLE_NAME;
  return me.memberships.every((m) => m.roleName === EMPLOYEE_ROLE_NAME);
}
